import React from 'react';

const BetaMessage = () => (
    <div style={{ backgroundColor: '#f8d7da', color: '#721c24', padding: '10px', textAlign: 'center' }}>
        This new application is currently in beta. If you experience any bugs, please report them
        <a
            href="https://contractortestla.com/technical-support/"
            style={{ color: '#721c24', textDecoration: 'underline', marginLeft: '5px' }}
            target="blank"
        >
            here
        </a>
        . We strongly suggest using
        <a
            href="https://www.google.com/chrome/"
            style={{ color: '#721c24', textDecoration: 'underline', marginLeft: '5px' }}
            target="blank"
        >
            Google Chrome
        </a>
        .
    </div>
);

export default BetaMessage;
